// see: https://stackoverflow.com/questions/44480644/string-union-to-string-array
export const FONT_RIGHT_KEYS = ['app', 'desktop', 'epub', 'web'] as const;
export type FontRightKeyTuple = typeof FONT_RIGHT_KEYS;
export type FontRightKey = FontRightKeyTuple[number];

// base price multipliers for each platform.
export interface IBucketLicenseTypeMultipliers {
    // used for self hosted
    web: number;
    app: number;
    ebook: number;
    cpu: number;
}

// compact representation of bucket multipliers/discounts.
export interface IBucketSlabs {
    // quantity is the maximum qty for which the multiplier or discount should apply
    [qty: number]: number;
    // this is
    unlimited?: number;
}

/**
 * Buckets are a set of possible license parameters and the associated multiplies and
 * discounts used to drive TN's pricing models.
 */
export interface IDjangoBucket {
    id: number;
    name: string;
    data: {
        // base price for this bucket.
        basePrice: number;

        // #region multipliers
        // pricing multipliers applied based on platform.
        platform: IBucketLicenseTypeMultipliers;
        // multipliers for # of publications in which the license will be used.
        ebook: IBucketSlabs;
        // multipliers for # of page views for cloud hosted web fonts
        web: IBucketSlabs;
        // multipliers for # of apps the license will be used for.
        app: IBucketSlabs;
        // multipliers for # of page views for self web fonts
        web_self_hosted: IBucketSlabs;
        // multiplier for # of cpus that will be allowed to use the license.
        cpu: IBucketSlabs;
        // #endregion

        // #region discounts
        // discounts to apply when a user orders multiple styles.
        style: IBucketSlabs;
        // discount to apply for multiyear licenses
        year: IBucketSlabs;
        // #endregion
    };
}


export interface IBucketOption {
    key: number | string; // key used for entities and HTML selects.
    value: number; // multiplier or discount
    label: string; // displayed in UI.
}

export interface IBucketOptions {
    // multipliers
    app: IBucketOption[]
    cpu: IBucketOption[]
    ebook: IBucketOption[]
    web: IBucketOption[]
    web_self_hosted: IBucketOption[]
    // discount
    year: IBucketOption[]
}

export interface IBucket extends IBucketOptions {
    basePrice: number;
    default?: boolean;
    // multipliers
    platform: IBucketLicenseTypeMultipliers,
    // discounts
    style: IBucketSlabs
}

export type BucketsIndex = {
    [djangoBucketId: number]:  IBucket
}
